import { createApp } from 'vue'
import VueClickAway from "vue3-click-away";
import VueGtag from "vue-gtag";

import App from "@mod/main/web_booking_consumer/App.vue";

import "@mod/css/style2.css";

if(import.meta.env.VITE_DEFAULT_CLASS == 'HAG') {
    import("@mod/css/styleHAG.css");
}

import router from "@mod/main/web_booking_consumer/routes";
import store from "@mod/tms/booking_engine/store/index";

createApp(App)
    .use(store)
    .use(VueGtag, {
        config: { id: import.meta.env.VITE_GA_ID },
        appName: import.meta.env.VITE_GA_APP_NAME,
        pageTrackerScreenviewEnabled: true
    }, router)
    .use(router)
    .use(VueClickAway)
    .mount('#app');